import React from 'react';
import "./styles.scss"

export default function Button(props) {
  const {onClick, children, ...rest} = props;
  const className = props.className || '';
  return (
    <button onClick={onClick} className={`${className}`} {...rest}>
      {children}
    </button>
  )
}
